import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Modal,
} from "reactstrap"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  EMERGENCY_TYPES_SEARCH,
  ADD_EMERGENCY_SUB_TYPES,
  LANGUAGES_SEARCH,
} from "../../helpers/api_endpoints"
import { useTranslation } from "react-i18next"

document.title = "Add Emergency Sub Type"

function AddEmergencySubType() {
  const { i18n } = useTranslation()
  const [title, setTitle] = useState('{"title":[{"1":""}]}')
  const [languages, setLanguages] = useState([])
  const [errorMsg, setErrorMsg] = useState([])
  const [loading, setLoading] = useState(false)
  const [valued, setValued] = useState({ title: [] })
  const [emergencyType, setEmergencyType] = useState([])
  const [emergencyTypeId, setEmergencyTypeId] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        // navigate('/collhub');
      })
  }, [])

  useEffect(() => {
    post(`${EMERGENCY_TYPES_SEARCH}`, { status: 1 })
      .then(response => {
        setEmergencyType(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        setErrorMsg(error.message)
      })
  }, [])

  const handleSubmit = () => {
    const config = { title, emergencyTypeId }

    console.log(config)

    // return

    post(ADD_EMERGENCY_SUB_TYPES, config)
      .then(response => {
        if (response.code == 201) {
          navigate("/emergency-sub-types", {
            state: { successMsg: "Emergency Sub Type Added SuccessFully" },
          })
        }
      })
      .catch(error => {
        seterrorMsg("Emergency Sub Type Creation Failed")
      })
  }

  const handleTitle = (languageId, value) => {
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setTitle(JSON.stringify(valued))
  }


   const getTranslatedText = (titleData, defaultText = "") => {
    try {
      if (typeof titleData === "string") {
        try {
          const parsed = JSON.parse(titleData)
          if (Array.isArray(parsed?.title)) {
            const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
            const langKey = langMap[i18n.language] || 1
            const titleObj = parsed.title.find(item => item && item[langKey])
            return titleObj ? titleObj[langKey] : defaultText
          }
          return parsed.title || defaultText
        } catch (e) {
          return titleData || defaultText
        }
      }

      if (titleData && typeof titleData === "object") {
        return getTranslatedText(titleData.title, defaultText)
      }

      return defaultText
    } catch (error) {
      console.error("Error in getTranslatedText:", error)
      return defaultText
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Emergency Sub Types"
            breadcrumbItem="Add Emergency Sub Type"
          />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Emergency Type</Trans>
                        </Label>
                        <Input
                          name="emergency_type"
                          className="form-control"
                          placeholder="Enter  Emergency Type"
                          type="select"
                          value={emergencyTypeId}
                          onChange={e => setEmergencyTypeId(e.target.value)}
                        >
                          <option value="">Select Emergency Type</option>
                          {emergencyType.map((item, index) => (
                            <option key={index} value={item.id}>
                              {getTranslatedText(item.title, "")}
                            </option>
                          ))}
                        </Input>
                      </div>
                    </Row>
                    <Row>
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Title ({language.name})</Trans>
                            </Label>
                            <Input
                              name="title"
                              className="form-control"
                              placeholder="Enter  Title"
                              type="text"
                              onChange={e =>
                                handleTitle(language.id, e.target.value)
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                    </Row>

                    <div className="mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddEmergencySubType
